import { useEffect, useState } from "react";

export const MSB_AGENT_FORM_URL = "https://form.typeform.com/to/u77wrrsi";
export const MSB_AGENT_VIDEO_URL =
  "https://cdn.mystrengthbook.com/misc/msb-agent/walkthrough.mp4";
export const MSB_AGENT_POSTER_URL =
  "https://cdn.mystrengthbook.com/misc/msb-agent/poster.jpg";

type MsbAgentUser = {
  _id: unknown;
  welcomeVideos?: Record<string, boolean>;
};

const OPEN_EVENT = "msb-agent:open";
const SEEN_EVENT = "msb-agent:seen";
const SEEN_KEY = "msbAgentModalSeen";

// Opened this page load; the user object only refreshes on the next request.
const openedByUser = new Set<string>();

const hasSeen = (activeUser?: MsbAgentUser) =>
  !activeUser ||
  Boolean(activeUser.welcomeVideos?.[SEEN_KEY]) ||
  openedByUser.has(String(activeUser._id));

/** Opens the modal from any trigger; pass the clicked element since Safari doesn't focus buttons on click. */
export const openMsbAgent = (
  trigger: Element | null = document.activeElement,
  activeUser?: MsbAgentUser
) => {
  if (activeUser && !hasSeen(activeUser)) {
    openedByUser.add(String(activeUser._id));
    fetch("/actions/user/video-shown", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ type: SEEN_KEY }),
    }).catch(() => {});
  }
  window.dispatchEvent(new CustomEvent(OPEN_EVENT, { detail: { trigger } }));
  window.dispatchEvent(new Event(SEEN_EVENT));
};

export const onMsbAgentOpen = (
  handler: (trigger: HTMLElement | null) => void
) => {
  const listener = (event: Event) =>
    handler((event as CustomEvent).detail?.trigger ?? null);
  window.addEventListener(OPEN_EVENT, listener);
  return () => window.removeEventListener(OPEN_EVENT, listener);
};

export const useMsbAgentSeen = (activeUser?: MsbAgentUser) => {
  const [, rerender] = useState(0);
  useEffect(() => {
    const update = () => rerender((count) => count + 1);
    window.addEventListener(SEEN_EVENT, update);
    return () => window.removeEventListener(SEEN_EVENT, update);
  }, []);
  return hasSeen(activeUser);
};
